import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from './store';
import { getBaseUrl } from './api';

export const prepareAssessmentHeaders = (headers: Headers, state: RootState) => {
  const token = state.assessmentsAuth.accessToken;
  // Add assessment token if available
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return headers;
};

/**
 * Assessment-specific baseQuery with token authentication
 * Separate from member web authentication to maintain clean boundaries
 */
const assessmentBaseQuery = fetchBaseQuery({
  baseUrl: getBaseUrl(), // Reuse same environment logic
  prepareHeaders: (headers, { getState }) =>
    prepareAssessmentHeaders(headers, getState() as RootState),
});

/**
 * Separate RTK Query API instance for assessments with token-based authentication
 * This maintains clean separation from member web authentication patterns
 */
export const AssessmentsApi = createApi({
  reducerPath: 'assessmentsApi',
  baseQuery: assessmentBaseQuery,
  tagTypes: ['Assessment', 'AssessmentAnswer', 'AssessmentQuestion', 'AssessmentAuth'],
  endpoints: () => ({}),
});
